module.exports = __webpack_public_path__ + "static/media/iconExamples.eac20b08.jpg";